<template>
    <div class="page" data-page="friends">
        <div class="mapWrapper">

            <div id="map">
                <MglMap
                    :accessToken="accessTokens[0]"
                    :mapStyle.sync="mapSettings.style"
                    :center="mapSettings.center"
                    :zoom="mapSettings.zoom"
                    @load="initMap"
                >
                </MglMap>
            </div>

            <div class="peopleArea">
                <p class="om-label">Friends ({{ getFriendsWithLocation.length }})</p>

                <div v-if="getFriendsWithLocation.length > 0" class="friendsList">
                    <div
                        v-for="member in getFriendsWithLocation"
                        :key="`friend_${member.uid}`"
                        class="friendItem container-lg clearfix"
                    >
                        <div class="col-2 float-left left">
                            <div class="avatar" :style="`background-image:url(${member.photoURL}?width=150&height=150);`">
                                <MemberStatus :memberId="member.uid"></MemberStatus>
                            </div>
                        </div>
                        <div class="col-8 float-left center">
                            <div>
                                <p class="name">{{ member.displayName }}</p>

                                <p v-if="member.geoInfo">
                                    {{ member.geoInfo.city + ', ' + member.geoInfo.region }}
                                </p>
                                <template v-else>
                                    <p v-if="userHasLocation(member)" class="location">
                                        {{ member.location.city.name }}, {{ member.location.state.name }}
                                    </p>
                                    <p v-else-if="member.ipaddress">{{ member.ipaddress }}</p>
                                </template>
                            </div>
                        </div>
                        <div class="col-2 float-left right">
                            <a v-if="member.geoInfo" @click.prevent="PanTo(member)" class="iconBtnCircle">
                                <ion-icon name="navigate"></ion-icon>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import moment from 'moment'
import Mapbox from 'mapbox-gl/dist/mapbox-gl'
import 'mapbox-gl/dist/mapbox-gl.css'
import { MapboxStyleSwitcherControl } from 'mapbox-gl-style-switcher'
import 'mapbox-gl-style-switcher/styles.css'
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder'
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css'
import MapboxDraw from '@mapbox/mapbox-gl-draw'
import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css'
import {
    MglMap,
    MglGeojsonLayer,
    MglPopup
} from 'vue-mapbox/dist/vue-mapbox.umd.js'
const parksData = require('@/data/parks.json')
const bcAreasData = require('@/data/bc_areas.json')
import MemberStatus from '@/components/MemberStatus'

export default {
    components: {
        MglMap,
        MglGeojsonLayer,
        MglPopup,
        MemberStatus
    },

    data(){
        return{
            loading: false,
            accessTokens: [
                'pk.eyJ1IjoibWlrZWhhbWlsdG9uMDAiLCJhIjoiNDVjS2puUSJ9.aLvWM5BnllUGJ0e6nwMSEg',
                'pk.eyJ1IjoiYnBhY2h1Y2EiLCJhIjoiY2lxbGNwaXdmMDAweGZxbmg5OGx2YWo5aSJ9.zda7KLJF3TH84UU6OhW16w',
                'pk.eyJ1IjoibW9uZ29sbGlzdCIsImEiOiIwYjBhZjRhNjJiNmFlNWYzODFlNmU5MGY4MzFkZTExNSJ9.Dz7pcSgryLYQAtoKLryzow'
            ],
            mapSettings: {
                style: 'mapbox://styles/mapbox/dark-v10?optimize=true',
                center: [-123.1207, 49.2827],
                zoom: 4
            },
            locations: [],
            friendsWithGeoInfo: []
        }
    },

    created(){
        this.map = null
        this.popup = null
        this.markers = []
    },

    computed: {
        getFriendsWithLocation(){
            let allFriends = this.$store.state.allUsersNew
            let friends = []

            for(let i = 0; i < allFriends.length; i++){
                let friend = allFriends[i]

                if(typeof friend.geoInfo !== 'undefined'){
                    this.friendsWithGeoInfo.push(friend)
                }

                if(this.userHasLocation(friend)){
                    if(this.locations.indexOf(friend.location.city.name) === -1){
                        this.locations.push(friend.location.city.name)
                    }
                    friends.push(friend)
                }else if(typeof friend.systemLocation !== 'undefined'){
                    friends.push(friend)
                }else if(typeof friend.ipaddress !== 'undefined'){
                    friends.push(friend)
                }
            }

            return friends
        },
    },

    methods: {
        // Map
        async initMap(event){

            // Setup Map
            this.map = event.map
            this.asyncActions = event.component.actions

            // Controls
            this.map.addControl(new Mapbox.NavigationControl({
                position: 'bottom-right'
            }))
            this.map.addControl(new Mapbox.GeolocateControl({
                positionOptions: {
                    enableHighAccuracy: true
                },
                trackUserLocation: true
            }))
            this.map.addControl(new MapboxStyleSwitcherControl())

            // Create Popup
            this.popup = new Mapbox.Popup({
                maxWidth: '300px'
            })

            // Map Events
            this.map.on('moveend', () => {
                console.log('Map move end')
            })

            // Markers & Layers
            this.bounds = this.map.getBounds()
            this.getAllFriends()
        },

        addMarkers(){
            console.log('Add Markers: ', this.friendsWithGeoInfo)

            for(let i = 0; i < this.friendsWithGeoInfo.length; i++){
                let friend = this.friendsWithGeoInfo[i]

                // Create Marker Element
                let el = document.createElement('div')
                let classes = 'marker friendMarker'
                el.className = classes
                el.id = `marker_${friend.uid}`
                el.data = friend

                // Marker Settings
                let marker = new Mapbox.Marker(el)
                let coordinates = [friend.geoInfo.ll[1], friend.geoInfo.ll[0]]

                console.log('Friend geo info: ', friend.geoInfo)
                console.log('Set marker coordinates: ', coordinates)

                marker.setLngLat(coordinates).addTo(this.map)

                el.addEventListener('click', (e) => {
                    let friend = e.target.data
                    console.log('Marker clicked: ', friend.displayName)
                })
                el.addEventListener('mouseenter', (e) => {
                    e.target.classList.add('active')
                    this.popup.setLngLat(coordinates)
                        .setHTML(this.getFriendPopupHTML(e.target.data))
                        .addTo(this.map)
                })
                el.addEventListener('mouseleave', (e) => {
                    this.closePopups()
                    e.target.classList.remove('active')
                })

                this.markers.push(marker)
            }
        },
        getFriendPopupHTML(friend){
            return `<div class="popupContent">
                <div class="dataItem">
                    <div class="avatar" style="background-image:url(${friend.photoURL});"></div>
                    <p>${friend.firstName}</p>
                </div>
            </div>`
        },
        closePopups(){
            if(this.popup !== null){
                this.popup.remove()
            }
        },
        openPopup(friend){
            let coordinates = [friend.geoInfo.ll[1], friend.geoInfo.ll[0]]
            let html = this.getFriendPopupHTML(friend)
            
            this.closePopups()
            this.popup.setLngLat(coordinates).setHTML(html).addTo(this.map)
        },
        async PanTo(friend){
            this.closePopups()

            let coordinates = [friend.geoInfo.ll[1], friend.geoInfo.ll[0]]
            let html = this.getFriendPopupHTML(friend)

            await this.asyncActions.flyTo({
                center: coordinates,
                zoom: 9,
                speed: 1
            }).then(() => {
                this.popup.setLngLat(coordinates).setHTML(html).addTo(this.map)
            })
        },

        // Friends
        getAllFriends(){
            let allFriends = this.getFriendsWithLocation

            console.log('All friends: ', allFriends)
            console.log('Locations: ', this.locations)

            this.processIpAddresses(allFriends)
            this.addMarkers()
        },

        async processIpAddresses(people){

            let batchProcess = []

            for(let i = 0; i < people.length; i++){
                let friend = people[i]

                if(typeof friend.geoInfo === 'undefined'){
                    if(typeof friend.ipaddress !== 'undefined'){
                        batchProcess.push(await this.getUserGeoLocation(friend))
                    }
                }
            }

            if(batchProcess.length === 0) return

            console.log('Processing: ', batchProcess.length)

            Promise.all(batchProcess).then(res => {
                console.log('Successfully processed ip addresses: ', res)
            }).catch(err => {
                console.log('Error processing ip address: ', err)
            })
        },

        async getUserGeoLocation(person){
            if(typeof person.ipaddress !== 'undefined'){
                let userRef = this.$firebase.firestore().collection('users').doc(person.uid)

                console.log('User has ip address: ', person.displayName, person.ipaddress)

                return this.$http.post(`https://us-central1-vanmgl.cloudfunctions.net/ipToGeo`, {
                    ipaddress: person.ipaddress
                }).then(async(res) => {
                    if(res.status === 200){
                        if(res.body){
                            if(typeof res.body.data !== 'undefined'){

                                let userGeoLocation = res.body.data

                                console.log('Received user geo location: ', person.displayName, userGeoLocation)
                                
                                return userRef.update({geoInfo: userGeoLocation}).then(() => {
                                    console.log('Successfully saved user geo info: ', person.displayName)
                                    return userGeoLocation
                                }).catch(err => {
                                    console.log('Error saving user geo info: ', person.displayName, err)
                                    return 'Failed on Save'
                                })
                            }
                        }
                    }
                    return 'Not Passed'
                }).catch(err => {
                    console.log('Error getting geo location for user: ', person.displayName, err)
                    return 'Failed to get geo info'
                })
            }else{
                return 'Did not pass!!!'
            }
        },
        userHasLocation(member){
            if(typeof member.location !== 'undefined' && member.location !== null){
                if(typeof member.location.city !== 'undefined' && member.location.city !== null){
                    return true
                }
            }
            return false
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/views/Friends.vue